import { FaqCategoryItem } from "../../types";

import { STUDENT_CSV_DOWNLOAD_UNAVAILABLE_FAQ } from "./StudentCsvDownloadUnavailableFaq";
import { EDIT_BOX_SETTINGS_FAQ } from "./EditBoxSettingsFaq";
import { SMARTPHONE_OPERATION_UNAVAILABLE_FAQ } from "./SmartphoneOperationUnavailableFaq";

export const GEAR_ITEMS: FaqCategoryItem[] = [
  STUDENT_CSV_DOWNLOAD_UNAVAILABLE_FAQ,
  EDIT_BOX_SETTINGS_FAQ,
  SMARTPHONE_OPERATION_UNAVAILABLE_FAQ,
];
